export type HistoricoPlanoTerminologia = 'CIAP2' | 'CID11' | 'PROCEDIMENTO'

export const labelTerminologia: Record<HistoricoPlanoTerminologia, string> = {
  CIAP2: 'CIAP 2',
  CID11: 'CID 11',
  PROCEDIMENTO: 'SIGTAP',
}

export interface HistoricoPlanoIntervencaoItem {
  id: string
  descricao: string
  codigo: string
  terminologia: HistoricoPlanoTerminologia
  nota?: string | null
}
